import React from 'react';
import { useLocation } from 'react-router-dom';

const Failure = () => {
  const location = useLocation();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center mt-4" style={{ height: '80vh' }}>
      <i className="bi bi-x-circle text-light" style={{ fontSize: 36 }}></i>
      <p className="px-3 text-center text-light fw-normal mb-0" style={{ fontSize: 20 }}>
        {location?.state?.message}
      </p>
    </div>
  );
};

export default Failure;